import { AxiosError } from "axios";
import { useQuery } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getSingleTestResultsUrl } from "@src/config/baseUrls";
import { queryKeys } from "@src/config/queryKeys";
import { TestStatus } from "@src/modules/shared/types";

export interface ImagesRange {
  start: number;
  end: number;
}

export interface TestResults {
  resultStatus: TestStatus;
  isSupportingRelativeTests: boolean;
  isBaseTest: boolean;
  results: Result[];
  description?: string;
  errorMessage?: string;
  testParameters: TestParameters;
  imagesRange?: ImagesRange;
  additionalDescription: string;
  dicomsCount: number;
}

export interface TestParameters {
  phantomParameters: { key: string; value: string }[];
  exposureParameters: { key: string; value: string }[];
  acquisitionParameters: { key: string; value: string }[];
}

export interface Result {
  id: number;
  isVirtual: boolean;
  label: string;
  value: string;
  notes: string;
  correctedValue?: number;
  valueType: "Number" | "Boolean" | "String" | "Notes";
  unit?: string;
  tolerance?: string;
  range?: string;
  isFailed: boolean;
  referenceValue?: number;
  difference?: number;
  tooltip?: TestTooltip;
}

export interface TestTooltip {
  text: string;
  imagePath: string;
}

const useTestResults = (studyId?: string, testId?: string) => {
  const axios = useAxios();

  return useQuery<TestResults, AxiosError>(
    [queryKeys.SINGLE_TEST_RESULTS, studyId, testId],
    async () => {
      const { data } = await axios.get(
        getSingleTestResultsUrl(studyId ?? "", testId ?? ""),
      );
      return data;
    },
    { enabled: !!studyId && !!testId },
  );
};

export default useTestResults;
